import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';
import { toast } from 'react-toastify';
import ModalUpdateBeat from './components/ModalUpdateBeat';

export default class BeatManagerPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            songs: [],
            selectedSong: null,
            loading: false,
            searchTerm: ''
        };
        this.getAllSongs = this.getAllSongs.bind(this);
        this.handleDeleteSong = this.handleDeleteSong.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    componentDidMount() {
        this.getAllSongs();
    }

    getAllSongs() {
        this.setState({ loading: true });
        
        const url = `${global.config.apiDomain}/yt-song/web/karaoke-song`;
        
        axios.get(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                let songsData = [];
                
                // Xử lý nhiều format response khác nhau
                if (res.data && res.data.data && Array.isArray(res.data.data.songs)) {
                    songsData = res.data.data.songs;
                } else if (Array.isArray(res.data)) {
                    songsData = res.data;
                } else if (res.data && Array.isArray(res.data.data)) {
                    songsData = res.data.data;
                } else if (res.data && res.data.status === 'OK' && res.data.data && Array.isArray(res.data.data.songs)) {
                    songsData = res.data.data.songs;
                } else if (res.data && res.data.status === 'OK' && Array.isArray(res.data.data)) {
                    songsData = res.data.data;
                } else if (res.data && typeof res.data === 'object') {
                    const findArray = (obj) => {
                        for (let key in obj) {
                            if (Array.isArray(obj[key])) {
                                return obj[key];
                            } else if (obj[key] && typeof obj[key] === 'object') {
                                const found = findArray(obj[key]);
                                if (found) return found;
                            }
                        }
                        return null;
                    };
                    const foundArray = findArray(res.data);
                    if (foundArray) {
                        songsData = foundArray;
                    }
                }
                
                this.setState({
                    songs: songsData,
                    loading: false
                });
            })
            .catch(error => {
                const errorMessage = error.response?.data?.message || error.message || 'Không thể tải danh sách beat';
                toast.error(errorMessage);
                this.setState({ 
                    songs: [],
                    loading: false 
                });
            });
    }

    handleDeleteSong(songId) {
        if (!window.confirm('Bạn có chắc chắn muốn xóa beat này?')) {
            return;
        }

        const url = `${global.config.apiDomain}/yt-song/web/karaoke-song/${songId}`;
        
        axios.delete(url)
            .then(res => {
                toast.success('Xóa beat thành công');
                this.getAllSongs();
            })
            .catch(error => {
                const errorMessage = error.response?.data?.message || error.message || 'Không thể xóa beat';
                toast.error(errorMessage);
            });
    }

    handleSearch(e) {
        this.setState({ searchTerm: e.target.value });
    }


    render() {
        const { songs, selectedSong, loading, searchTerm } = this.state;

        const filteredSongs = songs.filter(song => {
            if (!searchTerm) return true;
            const term = searchTerm.toLowerCase();
            return (
                (song.title && song.title.toLowerCase().includes(term)) ||
                (song.artistNames && song.artistNames.some(name => name.toLowerCase().includes(term)))
            );
        });

        try {
            return (
                <>
                    <ModalUpdateBeat 
                        song={selectedSong} 
                        onSuccess={this.getAllSongs}
                    />
                    <div id="content">
                        <div className="container-fluid" style={{ marginTop: '20px', padding: '20px' }}>
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h1 className="mb-0">Quản lý Beat</h1>
                                <button 
                                    className="btn btn-primary"
                                    data-toggle="modal"
                                    data-target="#ModalUpdateBeat"
                                    onClick={() => {
                                        this.setState({ selectedSong: null });
                                    }}
                                >
                                    <i className="fa-solid fa-plus mr-2"></i>
                                    Thêm beat mới
                                </button>
                            </div>
                            <hr />
                            
                            <div className="mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Tìm kiếm theo tên bài hát hoặc ca sĩ..."
                                    value={searchTerm}
                                    onChange={this.handleSearch}
                                />
                            </div>
                            
                            {loading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Đang tải...</span>
                                    </div>
                                    <p className="mt-2 text-muted">Đang tải danh sách beat...</p>
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col" style={{ width: '60px', backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>STT</th>
                                                <th scope="col" style={{ width: '120px', backgroundColor: '#e9ecef', textAlign: 'left', padding: '12px' }}>Ảnh bìa</th>
                                                <th scope="col" style={{ backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>Tên bài hát</th>
                                                <th scope="col" style={{ backgroundColor: '#e9ecef', textAlign: 'left', padding: '12px' }}>Ca sĩ</th>
                                                <th scope="col" style={{ width: '100px', backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>Giọng</th>
                                                <th scope="col" style={{ width: '100px', backgroundColor: '#e9ecef', textAlign: 'left', padding: '12px' }}>Tempo</th>
                                                <th scope="col" style={{ width: '200px', backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>Thao tác</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!filteredSongs || filteredSongs.length === 0 ? (
                                                <tr>
                                                    <td colSpan="7" className="text-center py-4">
                                                        <p className="text-muted mb-0">
                                                            {searchTerm ? 'Không tìm thấy beat nào' : 'Chưa có beat nào'}
                                                        </p>
                                                    </td>
                                                </tr>
                                            ) : (
                                                filteredSongs.map((song, index) => (
                                                    <tr key={song.id || index}>
                                                        <td className="align-middle" style={{ backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>{index + 1}</td>
                                                        <td className="align-middle" style={{ backgroundColor: '#e9ecef', textAlign: 'left', padding: '12px' }}>
                                                            {song.coverUrl ? (
                                                                <img 
                                                                    src={song.coverUrl} 
                                                                    alt={song.title}
                                                                    style={{ 
                                                                        width: '80px', 
                                                                        height: '80px', 
                                                                        objectFit: 'cover',
                                                                        borderRadius: '4px'
                                                                    }}
                                                                    onError={(e) => {
                                                                        e.target.src = 'https://via.placeholder.com/80?text=No+Image';
                                                                    }}
                                                                />
                                                            ) : (
                                                                <div 
                                                                    style={{ 
                                                                        width: '80px', 
                                                                        height: '80px', 
                                                                        borderRadius: '4px',
                                                                        backgroundColor: '#dee2e6',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                >
                                                                    <i className="fa-solid fa-music text-muted"></i>
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td className="align-middle" style={{ backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>
                                                            <strong>{song.title || 'N/A'}</strong>
                                                        </td>
                                                        <td className="align-middle" style={{ backgroundColor: '#e9ecef', textAlign: 'left', padding: '12px' }}>
                                                            {song.artistNames && song.artistNames.length > 0 ? (
                                                                <span>{song.artistNames.join(', ')}</span>
                                                            ) : (
                                                                <span className="text-muted">Chưa có ca sĩ</span>
                                                            )}
                                                        </td>
                                                        <td className="align-middle" style={{ backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>
                                                            {song.keyTone || '-'}
                                                        </td>
                                                        <td className="align-middle" style={{ backgroundColor: '#e9ecef', textAlign: 'left', padding: '12px' }}>
                                                            {song.tempo ? `${song.tempo} BPM` : '-'}
                                                        </td>
                                                        <td className="align-middle" style={{ backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>
                                                            <button 
                                                                className="btn btn-sm btn-info mr-2"
                                                                data-toggle="modal"
                                                                data-target="#ModalUpdateBeat"
                                                                onClick={() => {
                                                                    this.setState({ selectedSong: song });
                                                                }}
                                                            >
                                                                <i className="fa-solid fa-edit mr-1"></i>
                                                                Sửa
                                                            </button>
                                                            <button 
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => this.handleDeleteSong(song.id)}
                                                            >
                                                                <i className="fa-solid fa-trash mr-1"></i>
                                                                Xóa
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            );
        } catch (error) {
            return (
                <div id="content">
                    <div className="container-fluid" style={{ marginTop: '20px', padding: '20px' }}>
                        <h1>Quản lý Beat</h1>
                        <div className="alert alert-danger">
                            <strong>Lỗi:</strong> {error.message}
                        </div>
                    </div>
                </div>
            );
        }
    }
}

